import {
    createInsuranceCategoryApi,
    deleteInsuranceCategoryApi,
    getInsuranceCategoryAPi,
    getInsuranceCategoryByIdApi,
    updateInsuranceCategoryApi,
} from "../../helpers/backend_helper";

import {
    getInsuranceCategoryList,
    insuranceCategoryById,
    errorMessages,
    setLoading,
} from "./reducer";


export const getInsuranceCategoryListApi = (currentPage, pageSize, searchText) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "read", value: true }));
        let response;
        response = await getInsuranceCategoryAPi(currentPage, pageSize, searchText);
        const data = await response;
        dispatch(getInsuranceCategoryList(data));
        return true;
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return false;
    } finally {
        dispatch(setLoading({ type: "read", value: false }));
    }
};


export const getInsuranceCategoryById = (id) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "getById", value: true }));
        let response;
        response = getInsuranceCategoryByIdApi(id);
        const data = await response;
        dispatch(insuranceCategoryById(data));
        return true;
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return false;
    } finally {
        dispatch(setLoading({ type: "getById", value: false }));
    }
}

export const createInsuranceCategory = (data) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "create", value: true }));
        await createInsuranceCategoryApi(data);
        return { success: true, message: "Insurance Category Successfully Created" };
    } catch (error) {
        const errorMessage = error.response?.data?.errors || "Error creating insurance category";
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "create", value: false }));
    }
}


export const updateInsuranceCategory = (id, data) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "update", value: true }));
        await updateInsuranceCategoryApi(id, data);
        return { success: true, message: "Insurance Category Successfully Updated" }
    } catch (error) {
        const errorMessage = error.response.data.errors;
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "update", value: false }));
    }
}


export const deleteInsuranceCategory = (id) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "delete", value: true }));
        await deleteInsuranceCategoryApi(id);
        return { success: true, message: "Insurance Category successfully deleted" };

    } catch (error) {
        const errorMessage = error.response?.data?.errors || "An error occurred";
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "delete", value: false }));
    }
};